import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FilterSelect } from '@/shared/ui/FilterSelect';
import type { SelectOption } from '@/shared/ui/selectTypes';

type Props = {
  value: string;
  options: SelectOption[];
  placeholder: string;
  /** Query key of the table to refetch after saving. */
  queryKey: string;
  save: (value: string) => Promise<unknown>;
};

/** Select persisting its value immediately (goal parameter / traffic source). */
export const MetrikaSelectCell = ({ value, options, placeholder, queryKey, save }: Props) => {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: save,
    onSuccess: () => qc.invalidateQueries({ queryKey: [queryKey] }),
    onError: () => window.alert('Не удалось сохранить изменение'),
  });

  return (
    <FilterSelect
      options={options}
      value={value}
      placeholder={placeholder}
      isClearable={false}
      isDisabled={mutation.isPending}
      onChange={(next) => mutation.mutate(next)}
    />
  );
};
